import { useState } from 'react'
import { FileDownload } from '@/assets/icons'
import { CircularProgressContinuousSized } from '@/components/loaders/CircularProgressContinuous'
import { AnalyticsEvent } from '@/analytics/schema/events.schema'
import { trackMedSummaryEvent } from '@/analytics/utils/medsummary-analytics'
import { downloadMedSummaryAssetExcel } from '../fetch/download-med-summary-asset-excel'

interface MedSummaryAssetDownloadButtonProps {
  assetId: string
}

/**
 * Downloads the living billing summary as an Excel file.
 */
export default function MedSummaryAssetDownloadButton(props: MedSummaryAssetDownloadButtonProps) {
  const { assetId } = props
  const [isLoading, setIsLoading] = useState(false)

  const handleDownload = async () => {
    if (isLoading) return
    setIsLoading(true)
    trackMedSummaryEvent(AnalyticsEvent.MedSummaryAssetDownloadClicked, { medSummaryAssetId: assetId })
    try {
      await downloadMedSummaryAssetExcel(assetId, 'Medical Billing Summary.xlsx')
    } catch (error) {
      console.error('Error downloading billing summary Excel:', error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="inline-flex items-center justify-center w-7 h-7">
      {isLoading ? (
        <CircularProgressContinuousSized size={14} thickness={4} />
      ) : (
        <button
          onClick={handleDownload}
          className="w-7 h-7 flex items-center justify-center rounded-md ring-1 ring-brand-500 transition-colors hover:bg-brand-neutral-200"
          aria-label="Download the Medical Billing Summary"
        >
          <FileDownload className="w-4 h-4 text-brand-500" />
        </button>
      )}
    </div>
  )
}
